import { render, staticRenderFns } from "./RentingTips.vue?vue&type=template&id=df5e4848&scoped=true&"
import script from "./RentingTips.vue?vue&type=script&lang=ts&"
export * from "./RentingTips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5e4848",
  null
  
)

export default component.exports